export const REPLENISH_ROUTE_ROOT = '/replenish';

export const REPLENISH_ROUTES = {
  REPLENISH: REPLENISH_ROUTE_ROOT,
  ASSIGN: `${REPLENISH_ROUTE_ROOT}/assign`,
  LIST_SOURCE: `${REPLENISH_ROUTE_ROOT}/list/source`,
  LIST_DESTINATION: `${REPLENISH_ROUTE_ROOT}/list/destination`,
  TASK_SOURCE: `${REPLENISH_ROUTE_ROOT}/task/source/:skuId`,
  TASK_DESTINATION: `${REPLENISH_ROUTE_ROOT}/task/destination/:skuId`,
  SUMMARY: `${REPLENISH_ROUTE_ROOT}/summary`,
} as const;
